<!--
 * @Author: hzm
 * @Date: 2022-11-23 16:17:39
 * @Description: 企业管理控制台
-->

<!--
 * @Author: hzm
 * @Date: 2022-11-22 16:23:34
 * @Description: 
-->
<template>
  <div class="shop-container">
    <Transition name="slide-fade">
      <AdminHeader
        :title="platInfo.title"
        v-show="layoutStore.showHeader"
        :user-center-url="`/${platInfo.homePath}/userCenter`"
      >
      </AdminHeader>
    </Transition>
    <el-container style="border: 1px solid #eee" class="shop-container__inner">
      <Transition name="slide-fade">
        <div width="200px" class="shop-container__aside transition-all transition" v-if="layoutStore.showSider">
          <Sidebar class="sidebar-container" />
        </div>
        <!-- <p v-if="layoutStore.showSider">123</p> -->
      </Transition>
      <el-container class="shop-container__content">
        <!-- <el-header style="text-align: right; font-size: 12px">
                </el-header> -->

        <el-main class="shop-container__main">
          <!--  -->
          <Tool v-if="layoutStore.showSider"></Tool>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script setup lang="ts">
import type { RouteConfig } from 'vue-router';
import { primaryAdjustment, keyLabelAdjustment } from '@/utils/routerUtils';
import AdminHeader from './components/adminHeader.vue';
import Tool from './components/tool.vue';
import Sidebar from './components/Sidebar/index.vue';
import { headBreadcrumbMatched } from '@/composables/breadCrumb';
import { useRoute } from '../router/index';
import useLayoutStore from '@/stores/layout';
const layoutStore = useLayoutStore();

const router = useRouter();
const { proxy } = getCurrentInstance();
console.log('router: ', router.options.routes);

const activeMenu = computed(() => {
  const { meta, path } = proxy.$route;
  console.log('path123: ', path, proxy.$route);
  // 当前面包屑
  // 如果当前路由的meta中的hidden为true，则返回上一级路由的path
  if (meta?.hidden) {
    const curBreadCrumb = headBreadcrumbMatched(proxy.$route.matched.slice(2));
    return curBreadCrumb?.[curBreadCrumb.length - 2]?.path;
  }
  return path;
});

//   const toHome = to.path.split('/')?.[1] ?? '';

// 判断路由属于哪个平台
const platInfo = computed(() => {
  const route = useRoute();
  const homePath = route.path.split('/')?.[1] ?? '';
  return {
    title: homePath == 'shopplat' ? '商家中心' : '销售中心',
    homePath,
  };
});
</script>

<style scoped lang="scss">
.menu__item--text {
  display: flex;
  align-items: center;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s ease-in-out;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(-10px);
  opacity: 0;
}
</style>
